import { Stack, Text } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { ITableRowProps } from '~/components/molecules/Table';
import type { IIapPollVote } from '~/lib/api/modules/IapPolls';
import { QuerySkeleton } from '~/components/atoms/QuerySkeleton';
import { UserAvatar } from '~/components/atoms/UserAvatar';
import { Table } from '~/components/molecules/Table';
import { parseUserInfo } from '~/helpers/parseUserInfo';
import { useArticleQuery } from '~/lib/api/modules/Articles/hooks/useArticleQuery';

export type IIapPollVoteListItemProps = ITableRowProps & {
  vote: IIapPollVote;
};

export const IapPollVoteListItem: React.FC<IIapPollVoteListItemProps> = (
  props,
) => {
  const { vote, ...other } = props;
  const { t } = useTranslation();
  const userInfo = vote.user ? parseUserInfo(vote.user) : undefined;
  const articleQuery = useArticleQuery({
    appId: vote.appId,
    articleId: vote.articleId,
  });

  return (
    <Table.Row {...other}>
      <Stack as={Table.Body} horizontal gap={3}>
        <UserAvatar user={vote.user} />
        <Stack gap={1}>
          <Text variant="title" size="sm">
            {userInfo ? userInfo?.fullName : t('common.anonymous')}
          </Text>
        </Stack>
      </Stack>

      <Table.Body>
        <QuerySkeleton query={articleQuery} length={{ min: 24, max: 64 }}>
          {articleQuery.data?.title ?? vote.articleId}
        </QuerySkeleton>
      </Table.Body>

      <Table.Body>
        {vote.points} {t('IapPollVoteListItem.points')}
      </Table.Body>
    </Table.Row>
  );
};
